import React from "react";
import _ from "underscore";
import PropTypes from "prop-types";
import AnimatedDropdownWrapper from "components/source/shared/animated-dropdown-wrapper";

class SKUSelector extends React.Component {
  static propTypes = {
    skus: PropTypes.arrayOf(PropTypes.object).isRequired,
    label: PropTypes.string,
    name: PropTypes.string.isRequired,
    error: PropTypes.string,
    onBlur: PropTypes.func,
    onAnimatedInputChange: PropTypes.func,
    placeholder: PropTypes.string,
    id: PropTypes.string.isRequired,
    inline: PropTypes.bool,
    isRental: PropTypes.bool,
    isBulk: PropTypes.bool,
    isClearance: PropTypes.bool,
    sizeNames: PropTypes.object,
    value: PropTypes.string,
  };

  getHiddenFields = () => {
    var fields = [],
      skus = this.props.skus;

    if (skus.length === 1) {
      fields.push({
        name: this.props.name,
        value: skus[0].id,
      });
    }

    return fields;
  };

  isNotAvailable = () => {
    return !_.size(this.props.skus);
  };

  isOneSize = () => {
    return !this.isNotAvailable() && this.props.skus.length === 1;
  };

  getAvailabilitiesForMerchCat = sku => {
    if (!sku) {
      return {};
    }

    if (this.props.isRental) {
      return _.first(sku.rentalAvailabilities);
    }

    if (this.props.isBulk) {
      return _.first(sku.bulkAvailabilities);
    }

    if (this.props.isClearance) {
      return _.first(sku.clearanceAvailabilities);
    }

    return {};
  };

  getSKUOptions = skus => {
    if (this.isNotAvailable()) {
      return [{ label: "Not Available", value: "" }];
    }

    return _.map(
      skus,
      function (sku) {
        var availability = this.getAvailabilitiesForMerchCat(sku),
          disabled = availability?.count === 0;

        // We'll always have one of those availabilities nested in this SKU, even
        // if it's just the relationship. If that resource has a count and that
        // count is specifically zero (instead of just something falsy, like
        // undefined), we know this SKU is not available to add to the current
        // reservation.

        var label;
        if (this.props.sizeNames) {
          label = this.props.sizeNames[sku.size];
        } else {
          // Saleable items do not have sizeNames/sizeScales and so we default to a default here,
          // the sku's cannonicalSize.
          label = sku.size;
        }

        var skuOptions = {
          value: sku.id,
          disabled: disabled,
          label: label + (disabled ? " (Unavailable)" : ""),
        };

        return skuOptions;
      },
      this
    );
  };

  sizeUnavailable = (props, options) => {
    if (!options) {
      return false;
    }
    var selectedOption = _.findWhere(options, { value: props.value });
    return !!selectedOption?.disabled;
  };

  render() {
    var options = this.getSKUOptions(this.props.skus),
      error;

    // We might have selected a SKU before that, because our reservation has
    // changed, is now unavailable, so let's show an error.

    if (this.sizeUnavailable(this.props, options)) {
      error = "Size unavailable";
    } else {
      error = this.props.error;
    }

    if (this.isOneSize()) {
      return <input name={this.props.name} type="hidden" value={options[0].value} />;
    }

    if (!this.isNotAvailable()) {
      options.unshift({ label: this.props.placeholder || "Select", value: "" });
    }

    var value = this.props.value;
    if (value === null) {
      // When the value is set to null, we select the placeholder option
      value = "";
    }

    return (
      <AnimatedDropdownWrapper
        additionalClassName={"size-selector" + (this.props.inline ? "--inline" : "")}
        id={this.props.id}
        name={this.props.name}
        label={this.props.label}
        error={error}
        value={value}
        options={options}
        required={false}
        onChangeCallback={this.props.onAnimatedInputChange}
        onBlurCallback={this.props.onBlur}
      />
    );
  }
}

export default SKUSelector;
